import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import CreateSubsciption from "./CreateSubsciption";
import { UpperBoxSubscriptionListStyles } from "./css";
import SubscriptionTable from "./ListSubscription";
import { ViewSubscription } from "./ViewSubscription";
import { withAuth } from "../../hoc";
import { ISubscription } from "../../services/SubscriptionServices";

const Subscription = () => {
  const [showCreate, setShowCreate] = useState<boolean>(false);
  const [showView, setShowView] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [clonedData, setClonedData] = useState<ISubscription | null>(null);

  const openClonedSubscription = () => {
    setShowCreate(true);
  };

  const handledeleteClone = () => {
    setClonedData(null);
  };

  return (
    <>
      {!showCreate && !showView && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            maxHeight: "90.5vh",
            padding: 2,
          }}
        >
          <Box sx={UpperBoxSubscriptionListStyles}>
            <Typography variant="h6">Subscription</Typography>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setShowCreate(true)}
            >
              Create
            </Button>
          </Box>
          <Box>
            <SubscriptionTable
              setSelectedId={setSelectedId}
              setShowView={setShowView}
            />
          </Box>
        </Box>
      )}

      {showCreate && (
        <CreateSubsciption
          setShowCreate={setShowCreate}
          clonedData={clonedData}
          onEmptyClone={handledeleteClone}
        />
      )}
      {showView && (
        <ViewSubscription
          selectedSubscription={selectedId}
          setViewSubscription={setShowView}
          onClone={openClonedSubscription}
          setClonedData={setClonedData}
        />
      )}
    </>
  );
};

export default withAuth(Subscription);
